import React, { useEffect } from 'react';
import useCustomerSatisfactionSurvey from 'app/hooks/useCustomerSatisfactionSurvey';
import DriveFrame from './DriveFrame';

// Tempo de permanência na página antes de oferecer a pesquisa de satisfação —
// quem só passa pela tela não é perguntado. O cooldown de reexibição continua
// sendo do backend (GET /csat/drive).
const CSAT_DELAY_MS = 15_000;

export const MeuDrive: React.FC = () => {
  const csatSurveyFn = useCustomerSatisfactionSurvey(
    'drive',
    'Como você avalia a sua experiência com o Meu Drive?',
  );

  useEffect(() => {
    const timer = setTimeout(() => csatSurveyFn(), CSAT_DELAY_MS);

    return () => clearTimeout(timer);
  }, []);

  return <DriveFrame />;
};
